import React, { useEffect, useState } from "react";
import { AddButton, SearchToggleButton } from "../../../utils/Custom/Button";
import { AutoCompletes, TextFields } from "../../../utils/Custom/custominput";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { booleanOptions, qmsAuditor } from "../../constants/inspectionOption";
import "jspdf-autotable";
import html2pdf from "html2pdf.js";
import { QualificationExcel } from "./qualificationExcel";
import { getPermissions } from "../rbac/hasAccess";

const fields = [
  { label: "Mechanical", value: "Mechanical" },
  { label: "Electrical", value: "Electrical" },
];
const getLabel = (options, value) => {
  const match = options?.find((opt) => opt.id == value);
  return match ? match.label : "";
};
// Transform electrical data
const transformElectricalData = (data) => {
  return data?.map((row) => ({
    ...row,
    motors: getLabel(booleanOptions, row.motors),
    controlPanel: getLabel(booleanOptions, row.controlPanel),
    switchGears: getLabel(booleanOptions, row.switchGears),
    generators: getLabel(booleanOptions, row.generators),
    transformers: getLabel(booleanOptions, row.transformers),
    cablesWires: getLabel(booleanOptions, row.cablesWires),
    capacitors: getLabel(booleanOptions, row.capacitors),
    chargersInvertersUPS: getLabel(booleanOptions, row.chargersInvertersUPS),
    instruments: getLabel(booleanOptions, row.instruments),
    systemAuditor: getLabel(qmsAuditor, row.systemAuditor),
  }));
};

// Transform mechanical data
const transformMechanicalData = (data) => {
  return data?.map((row) => ({
    ...row,
    metalPlates: getLabel(booleanOptions, row.metalPlates),
    metalPipe: getLabel(booleanOptions, row.metalPipe),
    metalLinePipe: getLabel(booleanOptions, row.metalLinePipe),
    metalFlanges: getLabel(booleanOptions, row.metalFlanges),
    metalFittings: getLabel(booleanOptions, row.metalFittings),
    metalFasteners: getLabel(booleanOptions, row.metalFasteners),
    metalForging: getLabel(booleanOptions, row.metalForging),
    metalCasting: getLabel(booleanOptions, row.metalCasting),
    metalRolling: getLabel(booleanOptions, row.metalRolling),
    dabMetalPressureVessel: getLabel(
      booleanOptions,
      row.dabMetalPressureVessel
    ),
    dabMetalHeatExchangers: getLabel(
      booleanOptions,
      row.dabMetalHeatExchangers
    ),
    fabMetalColumns: getLabel(booleanOptions, row.fabMetalColumns),
    fabMetalReactors: getLabel(booleanOptions, row.fabMetalReactors),
    fabMetalTanks: getLabel(booleanOptions, row.fabMetalTanks),
    fabMetalPiping: getLabel(booleanOptions, row.fabMetalPiping),
    fabMetalPipeline: getLabel(booleanOptions, row.fabMetalPipeline),
    fabMetalStructurals: getLabel(booleanOptions, row.fabMetalStructurals),
    machinePumps: getLabel(booleanOptions, row.machinePumps),
    amchineValvs: getLabel(booleanOptions, row.amchineValvs),
    machineCompressors: getLabel(booleanOptions, row.machineCompressors),
    machineSkids: getLabel(booleanOptions, row.machineSkids),
    systemAuditor: getLabel(qmsAuditor, row.systemAuditor),
  }));
};

const QualificationReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [searchBy, setSearchBy] = React.useState("Mechanical");
  const [searched, setSearched] = React.useState(false);
  const [Mechanical, setMechanical] = useState([]);
  const [Electrical, setElectrical] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [exportMode, setExportMode] = useState(false);

  const downloadPDF = () => {
    setExportMode(true); // Apply class
    const element = document.getElementById("pdf-content");
    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: "table.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 4,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "landscape",
        compress: true,
      },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          // footer, if needed
        }
      })
      .save()
      .then(() => {
        setExportMode(false); // Clean up
      });
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchName("");
    fetchMechnicalDetails();
    fetchElectricalDetails();
  };

  const fetchElectricalDetails = async () => {
    try {
      const query = `SELECT emp.name AS emp_name, e.* FROM cam_electrical_inst e LEFT JOIN users u ON e.userID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id ORDER BY e.id DESC`;
      const cam_electrical_inst = await fetchQuery(query);
      // Transform data before setting state
      const transformedData = transformElectricalData(cam_electrical_inst);
      setElectrical(transformedData);
    } catch (error) {
      console.error("Error fetching cam_electrical_inst:", error);
    }
  };

  const fetchMechnicalDetails = async () => {
    try {
      const query = `SELECT emp.name AS emp_name, m.* FROM cam_mechanical m LEFT JOIN users u ON m.userID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id ORDER BY m.id DESC`;
      const cam_mechanical = await fetchQuery(query);
      // Transform data before setting state
      const transformedData = transformMechanicalData(cam_mechanical);
      setMechanical(transformedData);
    } catch (error) {
      console.error("Error fetching cam_mechanical:", error);
    }
  };

  useEffect(() => {
    fetchMechnicalDetails();
    fetchElectricalDetails();
  }, []);

  const handleSearch = async () => {
    if (!searchName) {
      alert("Please enter name.");
      return;
    }
    const searchKey = searchName.trim();
    try {
      if (searchBy === "Electrical") {
        const query = `SELECT emp.name AS emp_name, e.* FROM cam_electrical_inst e LEFT JOIN users u ON e.userID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id WHERE LOWER(emp.name) LIKE LOWER('%${searchKey}%') ORDER BY e.id DESC`;
        const cam_electrical_inst = await fetchQuery(query);
        const transformedData = transformElectricalData(cam_electrical_inst);
        setElectrical(transformedData);
      } else if (searchBy === "Mechanical") {
        const query = `SELECT emp.name AS emp_name, m.* FROM cam_mechanical m LEFT JOIN users u ON m.userID = u.id LEFT JOIN employees emp ON u.employeeId = emp.id WHERE LOWER(emp.name) LIKE LOWER('%${searchKey}%') ORDER BY m.id DESC`;
        const cam_mechanical = await fetchQuery(query);
        const transformedData = transformMechanicalData(cam_mechanical);
        setMechanical(transformedData);
      }

      setSearched(true);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-2 w-full">
        {/* Qualification Type */}
        <div className="col-span-1">
          <AutoCompletes
            id="search-field"
            label="Qualification Type"
            options={fields}
            value={searchBy}
            onChange={(e) => {
              setSearchBy(e);
              setSearched(false);
            }}
          />
        </div>

        {/* Name */}
        <div className="col-span-1">
          <TextFields
            id="searchby"
            label="Name"
            value={searchName}
            onChange={(e) => {
              setSearchName(e.target.value);
              setSearched(false);
            }}
          />
        </div>

        {/* Group buttons in a flex container */}
        <div className="col-span-1 flex md:col-span-2 lg:col-span-3 gap-5 flex-wrap">
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
          {(permissions.pdfDownload || permissions.allAccess) && (
            <AddButton
              id="btn-add-outline"
              label="Download PDF"
              onClick={downloadPDF}
            />
          )}
          {(permissions.excelDownload || permissions.allAccess) && (
            <QualificationExcel
              data={searchBy === "Electrical" ? Electrical : Mechanical}
              searchBy={searchBy}
            />
          )}
        </div>
      </div>

      <QualificationTable
        searchBy={searchBy}
        data={searchBy === "Electrical" ? Electrical : Mechanical}
        exportMode={exportMode}
      />
    </div>
  );
};

export default QualificationReport;

const QualificationTable = ({ data = [], searchBy, exportMode }) => {
  const exportClass =
    exportMode && searchBy === "Electrical"
      ? "pdf-export-electrical"
      : exportMode && searchBy === "Mechanical"
        ? "pdf-export-mechanical"
        : "";

  return (
    <div
      className={`w-full rounded-md shadow overflow-x-auto ${exportClass}`}
      id="pdf-content"
    >
      {searchBy == "Electrical" ? (
        <table className="min-w-full text-sm text-left text-gray-700">
          <thead className="bg-blue-50 text-xs capitalize font-medium text-gray-600">
            <tr>
              <th rowSpan={3} className="px-4 py-4 text-center border">
                Sr.No.
              </th>
              <th rowSpan={3} className="px-4 py-2 text-center border">
                Name
              </th>
              <th rowSpan={3} className="px-4 py-2 text-center border">
                Location
              </th>
              <th
                colSpan={1}
                rowSpan={2}
                className="px-4 py-2 text-center border"
              >
                Experience
              </th>
              <th rowSpan={3} className="px-4 py-2 text-center border">
                Basic Qualification
              </th>
              <th colSpan={9} className="px-4 py-2 text-center border">
                NABCB SCOPE SECTOR 19a
                <br />
                IEC 60034-2-1 (Motors) / IS STANDARDS
              </th>
              <th rowSpan={3} className="px-4 py-2 text-center border">
                QMS Auditor
              </th>
              <th rowSpan={3} className="px-4 py-2 text-center border">
                Remarks
              </th>
            </tr>
            <tr>
              <th colSpan={9} className="px-4 py-2 text-center border">
                Electrical Equipment
              </th>
            </tr>
            <tr>
              <th className="px-4 py-2 text-center border">Years</th>
              <th className="px-4 py-2 text-center border">Motors</th>
              <th className="px-4 py-2 text-center border">Control Panel</th>
              <th className="px-4 py-2 text-center border">Switch Gears</th>
              <th className="px-4 py-2 text-center border">Generators</th>
              <th className="px-4 py-2 text-center border">Transformers</th>
              <th className="px-4 py-2 text-center border">Cables & Wires</th>
              <th className="px-4 py-2 text-center border">Capacitors</th>
              <th className="px-4 py-2 text-center border">
                Battery Chargers / Inverters / UPS
              </th>
              <th className="px-4 py-2 text-center border">Instruments</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => (
              <tr key={row.id || index} className="hover:bg-gray-50">
                <td className="px-4 py-4 border text-center">{index + 1}</td>
                <td className="px-4 py-4 border">{row.emp_name}</td>
                <td className="px-4 py-4 border">{row.location}</td>
                <td className="px-4 py-4 border text-center">
                  {row.experience}
                </td>
                <td className="px-4 py-4 border">{row.qualification}</td>
                <td className="px-4 py-4 border text-center">{row.motors}</td>
                <td className="px-4 py-4 border text-center">
                  {row.controlPanel}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.switchGears}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.generators}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.transformers}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.cablesWires}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.capacitors}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.chargersInvertersUPS}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.instruments}
                </td>
                <td className="px-4 py-4 border text-center">
                  {row.systemAuditor}
                </td>
                <td className="px-4 py-4 border">{row.remarks}</td>
              </tr>
            ))}
            {data?.length === 0 && (
              <tr>
                <td
                  colSpan={16}
                  className="text-center py-4 text-gray-500 border"
                >
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        <table className="min-w-full text-sm text-left text-gray-700">
          <thead className="bg-blue-50 text-xs capitalize font-medium text-gray-600">
            <tr>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Sr.No.
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Name
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Location
              </th>
              <th rowSpan={2} className="border px-4 py-2 text-center">
                Experience
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Basic Quali.
              </th>
              <th
                colSpan={6}
                rowSpan={2}
                className="border px-4 py-2 text-center"
              >
                NDE
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                BGAS / NACE
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                API
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Welding
              </th>
              <th
                colSpan={9}
                rowSpan={1}
                className="border px-4 py-2 text-center"
              >
                NABCB SCOPE SECTOR 17a
                <br />
                (ASME: Sec. II Part A, Sec V)
                <br />
                ASTM (as applicable)
                <br />
                IS STANDARDS (IS4985, IS4984, IS 16647)
              </th>
              <th
                colSpan={8}
                rowSpan={1}
                className="border px-4 py-2 text-center"
              >
                "NABCB SCOPE SECTOR 17b
                <br />
                ASME: Sec. VIII Div 1 & 2, Sec V, Sec. IX, Sec II part B & C.,{" "}
                <br />
                ASME B31.3, API 1104 (Piping), ASTM (as applicable)
                <br />
                IS STANDARDS"
              </th>

              <th
                colSpan={4}
                rowSpan={1}
                className="border px-4 py-2 text-center"
              >
                "NABCB SCOPE SECTOR 18
                <br />
                Pump - API: 610, 674, 675. Valves - API: 598, 608, 6A & 6D
                <br />
                Compressors – API: 617, 618 & 619 Applicable ASME Standards IS
                15856 (Valves), "
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                System Auditor
              </th>
              <th rowSpan={3} className="border px-4 py-2 text-center">
                Remarks
              </th>
            </tr>
            <tr>
              <th colSpan={9} className="border px-4 py-2 text-center">
                Basic Metals
              </th>
              <th colSpan={8} className="border px-4 py-2 text-center">
                FABRICATED METAL PRODUCTS
              </th>
              <th colSpan={4} className="border px-4 py-2 text-center">
                MACHINERY & EQUIPMENT
              </th>
            </tr>
            <tr>
              <th className="border px-4 py-2 text-center">Years</th>
              <th className="border px-4 py-2 text-center">LPT</th>
              <th className="border px-4 py-2 text-center">RT</th>
              <th className="border px-4 py-2 text-center">UT</th>
              <th className="border px-4 py-2 text-center">MPT</th>
              <th className="border px-4 py-2 text-center">VT</th>
              <th className="border px-4 py-2 text-center">FET</th>
              <th className="border px-4 py-2 text-center">Plates</th>
              <th className="border px-4 py-2 text-center">Pipes</th>
              <th className="border px-4 py-2 text-center">Line Pipe</th>
              <th className="border px-4 py-2 text-center">Flanges</th>
              <th className="border px-4 py-2 text-center">Fittings</th>
              <th className="border px-4 py-2 text-center">Fasteners</th>
              <th className="border px-4 py-2 text-center">Forging</th>
              <th className="border px-4 py-2 text-center">Casting</th>
              <th className="border px-4 py-2 text-center">Rolling</th>
              <th className="border px-2 py-1 text-center">Pressure Vessels</th>
              <th className="border px-2 py-1 text-center">Heat Exchangers</th>
              <th className="border px-2 py-1 text-center">Columns</th>
              <th className="border px-2 py-1 text-center">Reactors</th>
              <th className="border px-2 py-1 text-center">Tanks</th>
              <th className="border px-2 py-1 text-center">Piping</th>
              <th className="border px-2 py-1 text-center">Pipeline</th>
              <th className="border px-2 py-1 text-center">Structurals</th>
              <th className="border px-2 py-1 text-center">Pumps</th>
              <th className="border px-2 py-1 text-center">Valves</th>
              <th className="border px-2 py-1 text-center">Compressors</th>
              <th className="border px-2 py-1 text-center">Skids</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => (
              <tr key={row.id || index}>
                <td className="border py-4 px-2 text-center">{index + 1}</td>
                <td className="border py-4 px-2">{row.emp_name}</td>
                <td className="border py-4 px-2">{row.location}</td>
                <td className="border py-4 px-2 text-center">
                  {row.experience}
                </td>
                <td className="border py-4 px-2">{row.qualification}</td>
                <td className="border py-4 px-2 text-center">{row.ndePlt}</td>
                <td className="border py-4 px-2 text-center">{row.ndeRt}</td>
                <td className="border py-4 px-2 text-center">{row.ndeUt}</td>
                <td className="border py-4 px-2 text-center">{row.ndeMpt}</td>
                <td className="border py-4 px-2 text-center">{row.ndeVt}</td>
                <td className="border py-4 px-2 text-center">{row.ndeFet}</td>
                <td className="border py-4 px-2 text-center">{row.bgas}</td>
                <td className="border py-4 px-2 text-center">{row.api}</td>
                <td className="border py-4 px-2 text-center">{row.welding}</td>
                <td className="border py-4 px-2 text-center">
                  {row.metalPlates}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalPipe}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalLinePipe}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalFlanges}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalFittings}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalFasteners}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalForging}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalCasting}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.metalRolling}
                </td>

                <td className="border py-4 px-2 text-center">
                  {row.dabMetalPressureVessel}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.dabMetalHeatExchangers}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalColumns}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalReactors}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalTanks}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalPiping}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalPipeline}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.fabMetalStructurals}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.machinePumps}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.amchineValvs}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.machineCompressors}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.machineSkids}
                </td>
                <td className="border py-4 px-2 text-center">
                  {row.systemAuditor}
                </td>
                <td className="border py-4 px-2">{row.remark}</td>
              </tr>
            ))}
            {data?.length === 0 && (
              <tr>
                <td
                  colSpan={37}
                  className="text-center py-4 text-gray-500 border"
                >
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};
